import React from "react";
import {
  Box,
  Typography,
  Button,
  Paper,
  Divider,
  List,
  ListItem,
  ListItemText,
} from "@mui/material";
import { ArrowBack, Print } from "@mui/icons-material";
import { renderChecklistV2 } from "../../print-v2";
import { useCompanyContext } from "../../Contexts/CompanyContext";
import { useShipSettings } from "../../Contexts/ShipSettingsContext";
import { getShipName } from "../../utils/domainSelectors";

export const ChecklistDetail = ({ checklist, goBack }) => {
  const { companyLogo } = useCompanyContext();
  const { shipData } = useShipSettings();

  return (
    <Paper
      elevation={3}
      sx={{
        p: 3,
        borderRadius: 3,
        backgroundColor: "background.paper",
      }}
    >
      {/* Header */}
      <Typography variant="h4" fontWeight="bold" gutterBottom>
        {checklist.title}
      </Typography>
      {/* Actions */}
      <Box
        sx={{
          display: "flex",
          justifyContent: "flex-end",
          gap: 2,
          mb: 1,
        }}
      >
        <Button
          variant="outlined"
          color="warning"
          onClick={goBack}
          startIcon={<ArrowBack />}
        >
          Back
        </Button>
        <Button
          variant="contained"
          color="primary"
          onClick={() =>
            renderChecklistV2({
              checklist,
              companyLogo,
              vesselName: getShipName(shipData),
            })
          }
          startIcon={<Print />}
        >
          Print Checklist
        </Button>
      </Box>

      <Divider sx={{ mb: 3 }} />

      {/* Sections */}
      {checklist.sections.map((section, i) => (
        <Box key={i} sx={{ mb: 4 }}>
          <Typography variant="h6" fontWeight="bold" gutterBottom>
            {section.title}
          </Typography>
          <List disablePadding>
            {section.items.map((item, idx) => (
              <ListItem key={idx} sx={{ py: 0.5, px: 0 }}>
                <ListItemText
                  primaryTypographyProps={{ variant: "body1" }}
                  secondaryTypographyProps={{
                    variant: "body2",
                    color: "text.secondary",
                    mt: 0.5,
                  }}
                  primary={`${idx + 1}. ${item.text}`}
                  secondary={item.note ? `Note: ${item.note}` : null}
                />
              </ListItem>
            ))}
          </List>
        </Box>
      ))}
    </Paper>
  );
};
